export interface GetListDTO {
  skip?: number
  limit?: number
  oderDirection?: OrderDirection
}

export enum OrderDirection {
  ASC = 'asc',
  DESC = 'desc',
}
